<!-- 编辑设备详情弹框 -->
<template>
  <div class="dialog-app-panel" :class="dataDialog ? 'dialog-show' : ''">
    <app-panel :isExpand="dataDialog" title="视频配置" @cancel="dataDialog = false">
      <!-- <el-dialog title="视频配置"
             :visible.sync="dataDialog"
             v-dialogDrag
             append-to-body> -->
      <div style="display: flex; justify-content: space-between; align-items: center">
        <span class="ml10">注：最多绑定9路摄像机</span>
        <el-button type="info" icon="el-icon-plus" @click="addCamera"
          >添加摄像机</el-button
        >
      </div>

      <ioc-table
        ref="devTab"
        :data="tableData"
        :option="option"
        :page="page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
        <!-- 定制操作栏按钮 -->
        <template slot="menu" slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('deviceAccess.button.delete')"
            placement="top"
            popper-class="tooltip-draw"
          >
            <el-button
              type="text"
              @click="delCamera(scope.row, scope.index)"
              icon="iconfont icon-shanchu"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="预览"
            placement="top"
            popper-class="tooltip-draw"
          >
            <el-button
              type="text"
              class="iconfont icon-Detail"
              @click="preview(scope.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </ioc-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="videoCancel">取消</el-button>
        <el-button type="primary" @click="videoConfirm">确定</el-button>
      </div>
      <!-- 摄像机树组件 -->
      <el-dialog
        title="设备树"
        :visible.sync="cameraVisible"
        v-dialogDrag
        append-to-body
        :modal="false"
        width="30%"
        class=""
      >
        <!-- <el-scrollbar class="device-tree-dialog"> -->
          <device-group-tree
            ref="deviceTree"
            v-if="cameraVisible"
            @cameraData="getCameraData"
            :multiCheck="true"
          >
          </device-group-tree>
        <!-- </el-scrollbar> -->

        <div slot="footer" class="dialog-footer">
          <el-button type="info" @click="cancleCamera">取 消</el-button>
          <el-button type="primary" @click="confirmCamera">确 定</el-button>
        </div>
      </el-dialog>
      <!-- </el-dialog> -->
    </app-panel>
  </div>
</template>
<script>
import { api } from "../api";
import appPanel from "@src/components/business/app-panel/index.vue";
import tableOption from "../const/videoTable";
// 摄像机组设备树
import deviceGroupTree from "./device-group-tree";
export default {
  components: {
    deviceGroupTree,
    appPanel,
  },
  props: {
    deviceType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      dataDialog: false,
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 0,
        pageSize: this.$utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      option: tableOption(this),
      tableData: [],
      cameraVisible: false,
      cameraIdList: [],
      deviceId: "",
    };
  },
  mounted() {},
  methods: {
    open(deviceId) {
      this.deviceId = deviceId;
      this.dataDialog = true;
      this.getList(deviceId);
    },
    addCamera() {
      this.cameraVisible = true;
      this.$nextTick(() => {
        this.$refs.deviceTree.$refs.tree.setCheckedKeys(this.cameraIdList);
      });
    },
    //获取运行数据列表
    getList(deviceId) {
      const params = {
        deviceId: deviceId,
      };
      this.$fetch(api.queryFirefightingCameraList, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.tableData = response.returnObj ? [...response.returnObj] : [];
        this.cameraIdList = this.tableData.map((item) => {
          return item.thirdCameraId;
        });
        this.page.total = response.returnObj ? response.returnObj.total : 0;
      });
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    getCameraData(data) {
      console.log("设备树的摄像机信息", data);
      this.newCameraData = [].concat(data);
      console.log("====this.newCameraData===", this.newCameraData);
    },
    confirmCamera() {
      if (this.newCameraData.length > 9) {
        this.$message.warning("最多选择9路摄像机视频");
        return;
      }
      this.tableData = [];
      this.cameraIdList = [];
      if (this.newCameraData.length) {
        this.tableData = this.newCameraData.map((item) => {
          this.cameraIdList.push(item.cameraIdList);
          return {
            thirdCameraId: item.thirdCameraId,
            cameraName: item.name,
          };
        });
      }
      this.cameraVisible = false;
    },
    cancleCamera() {
      this.cameraVisible = false;
    },
    delCamera(row, index) {
      this.tableData.splice(index, 1);
      this.cameraIdList.splice(index, 1);
    },
    // 打开视频播放组件
    preview(cameraInfo) {
      console.log(cameraInfo);
      this.$app.AppInstance.handleMiniPlay({
        playType: "live", // 'live',
        playTitle: cameraInfo.cameraName, //摄像机名称
        playId: cameraInfo.thirdCameraId, //摄像机id
      });
    },
    deleteVideo(ind) {},
    videoConfirm() {
      let cameraList = this.tableData.map((item) => {
        return {
          thirdCameraId: item.thirdCameraId,
        };
      });
      const params = {
        deviceId: this.deviceId,
        cameraList: cameraList,
      };
      this.$fetch(api.updateFirefightingCamera, params).then((response) => {
        if (response.success) {
          this.$message.success("视频配置保存成功");
          this.dataDialog = false;
          this.tableData = [];
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    videoCancel() {
      this.dataDialog = false;
      this.tableData = [];
    },
  },
};
</script>
<style lang="scss"></style>
